import { useTranslations } from 'next-intl';
import { cn } from '@/app/utils';
import { MEDIA_FILTERS } from '../../../constants';
import type { MediaFilter } from '../../../types';

interface MediaBrowserFiltersProps {
  value: MediaFilter;
  onChange: (filter: MediaFilter) => void;
}

export const MediaBrowserFilters = ({ value, onChange }: MediaBrowserFiltersProps) => {
  const t = useTranslations();

  return (
    <div className="mt-3 flex flex-wrap items-center gap-2">
      {MEDIA_FILTERS.map((filter) => {
        const active = value === filter;
        return (
          <button
            key={filter}
            type="button"
            className={cn(
              'rounded-full border px-2.5 py-1 text-xs transition',
              active
                ? 'border-system-white24 bg-system-white12 text-system-white'
                : 'border-system-white08 bg-transparent text-system-white40 hover:bg-system-white08 hover:text-system-white',
            )}
            onClick={() => onChange(filter)}
          >
            {t(`claw.assets.filters.${filter}`)}
          </button>
        );
      })}
    </div>
  );
};
